import React from "react";
import { useForm } from "react-final-form";
import { required } from "react-admin";
import { SelectInput } from "react-admin";
import { ICountryAppData } from "../../../common/redux/reducers/appDataReducer";
import "../styles/TwoInputsInRow.css";
import { ProtectedElement } from "../field-permissions/ProtectedElement";

interface IStateSelectorProps {
  formData: any;
  countries: ICountryAppData[];
  scopedFormData?: any;
  getSource?: ((source: string) => string) | undefined;
  countryIdProp: string;
  stateIdProp: string;
}

export const LicenceStateSelector = (props: IStateSelectorProps) => {
  const { formData, countries, countryIdProp, stateIdProp, ...rest } = props;
  const form = useForm();

  return (
    <div className="two-inputs-container">
      <ProtectedElement source={countryIdProp}>
        <SelectInput
          source={countryIdProp}
          label="resources.common.labels.licenceIssuingCountry"
          validate={required()}
          choices={countries}
          onChange={() => form.change("stateId", null)}
          {...rest}
        />
      </ProtectedElement>
      <ProtectedElement source={stateIdProp}>
        <SelectInput
          source={stateIdProp}
          label="resources.common.labels.licenceIssuingState"
          validate={required()}
          choices={
            countries.find((x) => x.id === formData[countryIdProp])?.states ??
            []
          }
          {...rest}
        />
      </ProtectedElement>
    </div>
  );
};
